import { render, staticRenderFns } from "./GlobalNavigationPane.vue?vue&type=template&id=65749fb5&scoped=true"
import script from "./GlobalNavigationPane.vue?vue&type=script&lang=ts"
export * from "./GlobalNavigationPane.vue?vue&type=script&lang=ts"
import style0 from "./GlobalNavigationPane.vue?vue&type=style&index=0&id=65749fb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65749fb5",
  null
  
)

export default component.exports